import { render, staticRenderFns } from "./BaseSelectWithLoadMore.vue?vue&type=template&id=bf674646&scoped=true"
import script from "./BaseSelectWithLoadMore.vue?vue&type=script&lang=js"
export * from "./BaseSelectWithLoadMore.vue?vue&type=script&lang=js"
import style0 from "./BaseSelectWithLoadMore.vue?vue&type=style&index=0&id=bf674646&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf674646",
  null
  
)

export default component.exports